<template>
    <div class="standalone-task-item">
        <div class="header">
            <span class="closeDrawer material-icons" @click="closeDrawer">close</span>
            <SearchResultAvatar :entity="entity" size="medium" />
            <h3>
                <router-link class="primary-link" :to="entity.link">
                    {{ entity.title }}
                </router-link>
            </h3>
            <h4>{{ entity.subtitle }}</h4>
        </div>
        <TaskItem :item="item" />
    </div>
</template>
<script>
import actions from '@/store/actions'
import SearchResultAvatar from '@/components/Search/avatar'
import TaskItem from './task-item.vue'

export default {
    name: 'StandaloneTaskItem',
    components: {
        SearchResultAvatar,
        TaskItem,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        this.$bus.subscribe('task-completed', this.taskCompleted)
    },
    beforeDestroy() {
        this.$bus.unsubscribe('task-completed', this.taskCompleted)
    },
    computed: {
        entity() {
            return this.item.entity
        },
    },
    methods: {
        closeDrawer() {
            this.$store.dispatch(actions.clearRightDrawer)
        },
        taskCompleted(item) {
            if (this.item.id === item.id && this.$store.getters.currentTaskItem?.id === this.item.id) {
                this.closeDrawer()
            }
        },
    },
}
</script>
<style>
.standalone-task-item {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    .closeDrawer {
        color: var(--color-primary-100);
        font-size: 16px;
        line-height: 16px;
        display: block;
        cursor: pointer;
        visibility: visible;
        position: relative;
        top: -16px;
        right: -8px;
        float: right;
    }

    > .header {
        background-color: #323135;
        overflow: hidden;
        padding: 40px 32px;
        text-overflow: ellipsis;
        white-space: nowrap;

        .avatar {
            float: left;
        }

        h3 {
            margin-bottom: 16px;
        }

        h4 {
            color: white;
            overflow: hidden;
            text-overflow: ellipsis;
            width: calc(100% - 96px);
        }
    }
}
</style>
